import React from 'react';

import styles from './OfflineMode.module.scss';

export type SkeletonBlockProps = {
  width?: string;
  height?: string;
  className?: string;
};

export function SkeletonBlock({ width, height, className }: SkeletonBlockProps) {
  return (
    <span
      aria-hidden="true"
      className={className ? `${styles.skeletonBlock} ${className}` : styles.skeletonBlock}
      data-test-id="skeletonBlock"
      style={{ width, height }}
    />
  );
}

export type SkeletonRegionProps = {
  label: string;
  testId?: string;
  children: React.ReactNode;
};

export function SkeletonRegion({ label, testId, children }: SkeletonRegionProps) {
  return (
    <div aria-busy="true" aria-live="polite" data-test-id={testId} className={styles.skeleton}>
      <span className={styles.srOnly}>{label}</span>
      {children}
    </div>
  );
}
